import { useCallback, useContext, useState } from 'react';
import { MultiSelect } from '@library/components/selects';
import { ResetIconButton } from '@library/components/buttons';
import { Searchbar } from '@library/components/inputs';
import type { SelectOption } from '@library/types/utils';
import { UserRolesContext } from '@bo-hooks/user/useAdminUsersContext';
import { useRoles } from '@bo-hooks/roles/useRoles';

export const UserRolesFilters = () => {
  const [resetFiltersDisabled, setResetFiltersDisabled] = useState(true);

  const { filters } = useContext(UserRolesContext);
  const { filteredRoles, searchValue, onSearch, onFilteredRolesChange } =
    filters;

  const { roleSelectOptions } = useRoles({ roles: undefined });

  const handleRoleOptionsChange = useCallback(
    (options: Array<SelectOption>) => {
      const isAllRoles = options.length === roleSelectOptions.length;
      const roles = options.map(({ value }) => value);

      onFilteredRolesChange(!isAllRoles ? roles : []);
      setResetFiltersDisabled(isAllRoles);
    },
    [roleSelectOptions, onFilteredRolesChange, setResetFiltersDisabled]
  );

  const handleReset = useCallback(() => {
    onFilteredRolesChange([]);
    setResetFiltersDisabled(true);
  }, [onFilteredRolesChange, setResetFiltersDisabled]);

  return (
    <>
      <Searchbar
        searchValue={searchValue}
        handleSearch={onSearch}
        placeholder="Search by Name, Email, or Role"
      />
      <div className="flex">
        <MultiSelect
          onChange={handleRoleOptionsChange}
          options={roleSelectOptions}
          label="Roles"
          size="small"
          testId="roles"
          disabled={false}
          values={filteredRoles}
          allOption
        />
        <ResetIconButton
          className="disabled:text-soClean-140"
          disabled={resetFiltersDisabled}
          label="Reset Filters"
          onClick={handleReset}
        />
      </div>
    </>
  );
};
